import React from "react";

const Experience = () => {
  const resumeContent = [
    {
      id: 1,
      colClass: "right",
      title: "Experience",
      resume: [
      {
        id: 1,
        year: "2024 - Now",
        degree1: "Partner",
        degree2: "",
        specialities: "Startup Scouting | Open Innovation | Product Strategy | Fundraising Support | Technical Due Diligence | Venture Building | Startup-Corporate Integration | Innovation Management | Business Development | Strategic Partnerships | Go-to-Market Strategy | Investment Structuring",
        skills: "Market Analysis · Financial Modeling · Product-Market Fit · Stakeholder Engagement · Deal Structuring · Technology Assessment · Strategic Thinking · Mentoring & Advising · Innovation Ecosystem · Investment Readiness · Early-Stage Validation",
        institute: "Aita Ventures · Venture Firm · Madrid ",
      },
      {
        id: 9,
        year: "2026 - Now",
        degree1: "Founder",
        degree2: "Founder of Blank Phone, a digital detox solution for families and adults who want to take back control over the time and attention smartphones consume.",
        degree3: "I lead the project end-to-end: product vision, experience design, development of the Android launcher and backend platform, device distribution, and the relationship with the families and schools that trust us.",
        degree4: "We build a smartphone that works as a tool, not as an imposed habit: a minimal interface, no open app stores, no engagement-driven feeds, no dark patterns. Only what the user — or the family — decides to keep in front of them.",
        degree5: "· Product — Deciding what belongs in the launcher and what doesn’t; every choice starts from the question \"does this respect the user’s time?\".",
        degree6: "· Technology — Building the Android launcher, the parent dashboard, and the cloud infrastructure that orchestrates devices, policies and notifications.",
        degree7: "· Business — Device distribution, working with families and schools, and shaping a sustainable commercial model that scales without betraying the purpose.",
        degree8: "I believe the first years with a smartphone shape someone’s lifelong relationship with technology — and that relationship can start well.",
        specialities: "Digital Detox | Product Vision | Experience Design | Android Launcher | Backend Platform | Cloud Infrastructure | Device Distribution | Parent Dashboard | Family & School Relationships | Device Orchestration | Policies & Notifications | Minimal UX | Sustainable Business Model | EdTech | ParentTech | Hardware Distribution | Go-to-Market",
        skills: "Product Strategy · Android Development · Cloud Architecture · UX Design · End-to-End Execution · Stakeholder Management · B2C & B2B Sales · Mission-Driven Leadership · Vision Setting · Entrepreneurship",
        institute: "Blank · Your Screen · Your Rules · Madrid",
      },
      {
        id: 2,
        year: "2024 - Now",
        degree1: "Co-founder",
        degree2: "",
        specialities: "Product Management | Stakeholder Management | Fundraising | Product and Service Development | Requirement Analysis | Pricing | Planning | Strategy",
        skills: "Problem Solving · Product Lifecycle Management · Cloud Architecture · Strategic Roadmaps · Full stack Developer · Innovation Management · IA ·Blockchain · GCP",
        institute: "Elevenais · StartUp · Madrid ",
      },{
        id: 3,
        year: "2017 - Now",
        degree1: "· 2026 - Now · Member of Business Angels Network @ BIGBAN",
        degree2: "· 2026 - Now · Mentor @ YOUBEFY",
        degree3: "· 2026 - Now · Member of Business Angels Network @ Fundacion Madri+d",
        degree4: "· 2025 - Now · Member of Business Angels Network @ IESE",
        degree5: "· 2025 - Now · Member of EJE&CON · Spanish Association of Executives and Directors",
        degree6: "· 2025 - Now · Business Mentor @ Fundacion Madri+d",
        degree7: "· 2024 - Now · Professor @ The Valley Business & Tech School",
        degree8: "· 2024 - Now · Mentor @ IESE WeStart Mentoring Program",
        degree9: "· 2024 - Now · Private Investor @ StartUpXplore",
        degree10: "· 2025 - Now · Business Mentor @ Fundacion Madri+d",
        degree11: "· 2018 - Now · Project Evaluator for European ICT Projects @ EU Commission, IMEC, AID4SME,StandICT",
        degree12: "· 2017 - Now · Conference Speaker",
        degree13: "· 2009 - Now · Associate and Collegiate @ COIT",
        degree14: "· 2017 - 2020 · Smart Cities Lecturer for Smart Cities Master @ Structuralia",
        specialities: "Startup Ecosystem | Open Innovation | Product Strategy | Deep Tech | Corporate Venturing | IoT | AI | Digital Product Development | Business Model Design | Industrialization | Hardware Manufacturing | Innovation Programs | Technical Due Diligence | Mentoring | Tech Scouting | Venture Building | Fundraising Support | Smart Cities | Scale-ups | Collaborative Pilots | Tech Transfer | Strategic Positioning | MVP Validation | Market Access | Partner Management | Go-to-Market",
        skills: "Innovation Strategy · Business Development · Product Management · Cross-Sector Collaboration · Startup Mentorship · Corporate Advisory · Technical Execution · Strategic Roadmaps · Go-to-Market Planning · Investment Readiness · Ecosystem Building",
        institute: "AMAREN VENTURES · Madrid",
      },
      {
        id: 4,
        year: "2019 - 2024",
        degree1: "Global Product and Solution Manager",
        degree2: "",
        specialities: "IoT | Business | Product Management | People Management | Stakeholder Management | Relationship Building | Understanding the customer | Product and Service Development | Requirement Analysis | Pricing | Planning | Competitive Analysis | Sales Planning | Inventory Control | Finacial Planning | Strategy",
        skills: "Problem Solving · Product Lifecycle Management · Product Launch · Strategic Roadmaps · User Experience (UX) · Innovation Management · Design Thinking · Competitive Analysis · Strategic Partnerships and Alliances · Technical Proficiency",
        institute: "SGS · Global . Madrid · Digital & Innovation",
      },

      {
        id: 5,
        year: "2015 - 2019",
        degree1: "IoT And Smart Cities Manager",
        degree2: "",
        specialities: "IoT & Smart Cities Expert | Water & Energy Industries | Open Innovation | Digital Transformation | Cutting-Edge Technologies | Public Tenders | IoT Initiatives | Smart Cities | Technical Architectures | Energy Consumption | Water Quality | Critical Infrastructures | Spin Off | Development Teams | Digital Partnerships | OneSait | arcGIS | IDBOX | LoraWAN | Sigfox | Angular | Libelium ",
        skills: "Business Development · Digital Transformation · Innovation Consulting · Product Development · Product Innovation",
        institute: "TPF ENGINEERING · Madrid · Engineering Consultancy",
      },
      {
        id: 6,
        year: "2013 - 2015",
        degree1: "Founder · Product Manager",
        degree2: "",
        specialities: "Tech Innovation | Market Analysis | Investor Pitching | Product Development | Marketing Strategy | Strategic Partnership | Negotiation Skills | Startup Financing | Incubator Program | Cutting-Edge Technologies | Investement Attraction | Networking and Relationship Building | Trade Shows and Events | POCs | MVPs | Strategic Thinking | Libelium | Java | Angular | Cloud | HW Design",
        skills: "IProduct Management · Competitive Analysis · Startups · Product Development · Entrepreneurship · Product Innovation · Technical Proficiency · Marketing",
        institute: "EOIT · Bilbao · Tech Start Up",
      },
      {
        id: 7,
        year: "2009 - 2013",
        degree1: "Hardware/Firmware Engineer",
        degree2: "Quality Manager",
        specialities: "Hardware Tools | Prototyping | Firmware | Validation Software | Smart Agriculture | Smart Devices | Smart Metering | Smart Cities | LoRaWAN | Coronis | CE/FCC Certification | Innovation | Quality Assurance | Performance Testing | Manufacturing Process | Compliance | Emerging Technologies | Mass Manufacturing | Process Optimization | KPIs | Data-driven Decision Making | ISO 9001 | Continuous Improvement | Top Management Insights | Process Enhacement | Proactive Risk Management | Operational Efficiency | Cross-Functional Leadership",
        skills: "Quality Management · Corrective and Preventive Action (CAPA) · Quality Auditing · Continuous Improvement · Cross-functional Team Leadership · Research and Development (R&D) · Manufacturing Engineering · Testing Methodologies and Validation · Hardware and Firmware Development",
        institute: "ARSONDATA METERING· Bilbao · Engineering",
      },
      {
        id: 8,
        year: "2008 - 2009",
        degree1: "Junior Engineer",
        degree2: "",
        specialities: "M2M Remote Stations Device Debugging and Development | Water and Energy Sectors | Embedded Systems Development | Cellular Remote Monitoring Expertise | Telecontrol | University Final Project with Honors",
        skills: "M2M Communication Expertise · Embedded Systems Development",
        institute: "ELECNOR GROUP · Bilbao · Renewable Engineering",
      }
      ],
    },
  ];
  return (
    <>
      {resumeContent.map((item) => (
        // <div className={item.colClass} key={item.id}>
        <div key={item.id}>
          <div className="tokyo_section_title">
            <h3>{item.title}</h3>
          </div>
          <div className="tokyo_tm_resume_list">
            <ul>
              {item?.resume?.map((value) => (
                <li key={value.id}>
                  <div className="list_inner">
                    <div className="time">
                      <span>{value.year}</span>
                    </div>
                    <div className="place">
                      <h3 style={{ color: "#333b4d" }}>{value.institute}</h3>
                      <span>{value.degree1}</span>
                      <div><span>{value.degree2}</span></div>
                      <div><span>{value.degree3}</span></div>
                      <div><span>{value.degree4}</span></div>
                      <div><span>{value.degree5}</span></div>
                      <div><span>{value.degree6}</span></div>
                      <div><span>{value.degree7}</span></div>
                      <div><span>{value.degree8}</span></div>
                      <div><span>{value.degree9}</span></div><br></br>
                      <div><span><strong>Specialities:</strong> {value.specialities}</span></div><br></br>
                      <div><span><strong>Skills:</strong> {value.skills}</span></div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export default Experience;
